module.exports = __webpack_public_path__ + "static/media/tab_checkmark_icon_inactive.1b1c5d02.svg";